import axios from 'axios';
import { getToken } from '@/utils/auth'
axios.defaults.timeout = 30000;
axios.defaults.baseURL ='';
// axios.defaults.withCredentials = true;


// 请求之前
axios.interceptors.request.use(
    config => {
        config.headers = {'AUTHORIZATION': getToken()};
        return config;
    },
    error => {
        console.log(error)
        return Promise.reject(error)
    }
);

// 数据拦截
axios.interceptors.response.use(
    response => {
        if (response.data.code === 'E000008') {
            return response;
        }
        return response;
    },
    error => {
        return Promise.reject(error)
    }
);


/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function get(url, params = {}) {
    return new Promise((resolve, reject) => {
        axios.get(url, {
            params: params
        }).then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err)
        })
    })
}


/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(url, data = {}, header = {}) {
    return new Promise((resolve, reject) => {
        console.log(url)
        console.log(data)
        console.log(header)
        axios.post(url, data, header).then(response => {
            resolve(response.data);
        }, err => {
            console.log(err)
            reject(err)
        })
    })
}

 /**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

 export function patch(url, data = {}) {
     return new Promise((resolve, reject) => {
         axios.patch(url, data)
             .then(response => {
                 resolve(response.data);
             }, err => {
                 reject(err)
             })
     })
 }

 /**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

 export function put(url, data = {}) {
     return new Promise((resolve, reject) => {
         axios.put(url, data)
             .then(response => {
                 resolve(response.data);
             }, err => {
                 reject(err)
             })
     })
 }
